import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-white text-black font-sans overflow-x-hidden">
      <Navbar />
      <main className="flex-grow pt-[72px] md:pt-20 overflow-x-hidden w-full">
        <Outlet /> 
      </main>
      <Footer />
    </div>
  );
}